import { Record } from "immutable"

export const BriefingModel = new Record({
    recipients: [],
    personalisation: "",
    introduction: ""
})
